<template>
	<section class="page page-extras-balldetector">
		<!-- <SceneTableDetector /> -->
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * Teachable Machine Webcam Classifier Component
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageExtrasBallDetector extends PageBase {}
</script>

<style lang="scss">
	.page-extras-balldetector {
		// Not implemented
	}
</style>
